// extracted by mini-css-extract-plugin
module.exports = {"root":"H1_root__CWYvV","flex":"H1_flex__UCf2L"};